import sharedData from '../../shared-data';

/**
 *
 * @returns {Promise<{[key: string]: any}>}
 */
function jQueryAjax(url, options) {
    return new Promise((resolve, reject) => {
        jQuery.ajax(url, options)
            .done(resolve)
            .fail(reject);
    });
}

export default function getRemoteServer() {
    let locked       = false,
        requestQueue = [];

    function isLocked() {
        return locked;
    }

    function lock() {
        locked = true;
    }

    async function release() {
        if (requestQueue.length) {
            await request(requestQueue.pop());
        } else {
            locked = false;
        }
    }

    /**
     * Creates local storage cache for a while
     * @param data
     */
    function storeData(data) {
        return window.localStorage.setItem('credentia_props_cache', JSON.stringify(data));
    }

    /**
     * Recovers either locally stored data, variable cache or false/null if nothing is present
     * @returns {*|boolean}
     */
    function getData() {
        return JSON.parse(window.localStorage.getItem('credentia_props_cache'));
    }

    let lastExpCheck = 0;

    async function hasUpdates() {
        if ((new Date()).getTime() - lastExpCheck < 10_000) {
            // Ignore expiration check if it was done less than 10 seconds ago
            return false;
        }
        const refTime = parseInt(window.localStorage.getItem('credentia_props_cache_ref_time')) || 0;
        try {
            const resp = await jQueryAjax(sharedData.ajaxurl, {
                method: 'POST',
                data: {
                    action: 'hasUpdates',
                    ref_time: refTime,
                },
            });
            lastExpCheck = (new Date()).getTime();
            return resp.has_updates || false;
        } catch (e) {
            console.warn(e);
            return false;
        }
    }

    function resolveDataType(data) {
        if (typeof data === 'string') {
            if (data === 'true') {
                return true;
            } else if (data === 'false') {
                return false;
            } else if (data === 'null') {
                return null;
            } else if (data.match(/^\d+$/)) {
                return parseInt(data);
            } else if (data.match(/^\d+\.?\d*$/)) {
                return parseFloat(data);
            } else {
                return data;
            }
        } else if (typeof data === 'object' && data instanceof Array) {
            return data.map(d => resolveDataType(d));
        } else if (data !== null && typeof data === 'object') {
            const obj = {};
            for (let prop in data) {
                if (data.hasOwnProperty(prop)) {
                    obj[prop] = resolveDataType(data[prop]);
                }
            }
            return obj;
        } else {
            return data;
        }
    }

    async function loadData() {
        const data = await jQueryAjax(sharedData.ajaxurl, {
            method: 'POST',
            data: {
                action: 'fetchAllProperty',
            },
            timeout: 60000,
        });

        if (data && typeof data.projekts !== 'undefined' && typeof data.objekts !== 'undefined') {
            window.localStorage.setItem('credentia_props_cache_ref_time', data.ref_time || 0);
            const processedData = resolveDataType(data);
            storeData(processedData);
            return processedData;
        } else {
            console.warn(data);
            throw new Error('Malformant data received');
        }
    }

    /**
     * Request data from server
     * Data should be processed in callback function.
     * Once downloaded, method will serve cached data.
     *
     * @param {(data: {[key: string]: any}) => any} callback
     */
    async function request(callback) {
        if (isLocked()) {
            requestQueue.push(callback);
            return;
        } else {
            lock();
        }

        let cache = getData();

        if (!cache || await hasUpdates()) {
            cache = await loadData();
        }
        await release();
        callback(cache);
        return cache;
    }

    return { request };

}
